import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // We want to enable this on a case by case scenario
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
